import { useSelector  } from "react-redux";
import { RootState } from "../store/index";
import { TaxDocumentStatus } from '../enums/tax';

/*
 * Convenience hooks to reference
 * Tax Return state from store
 */
export const isTaxReturnComplete = (): boolean => {
  const { backendState: { status } } = useSelector((store: RootState) => store.state);

  return status === TaxDocumentStatus.Complete;
}

export const isTaxReturnAwaitingDocuments = (): boolean => {
  const { backendState: { status } } = useSelector((store: RootState) => store.state);

  return status === TaxDocumentStatus.AwaitingDocuments;
}

export const isTaxReturnAwaitingPayment = (): boolean => {
  const { finalBalance } = useSelector((store: RootState) => store.payment);

  // Note: if backend changes this logic, it will also need to be updated here.
  return isTaxReturnComplete() && finalBalance.final_balance > 0;
}

export const isTaxReturnAwaitingSignature = (): boolean => {
  const { backendState: { status } } = useSelector((store: RootState) => store.state);

  return status === TaxDocumentStatus.AwaitingSignature;
}

export const isTaxReturnAwaitingRefund = (): boolean => {
  const { finalBalance } = useSelector((store: RootState) => store.payment);

  // Note: if backend changes this logic, it will also need to be updated here.
  return isTaxReturnComplete() && finalBalance.final_balance < 0;
}

export const isTaxReturnNotRequired = (): boolean => {
  const { backendState: { status } } = useSelector((store: RootState) => store.state);

  return status === TaxDocumentStatus.NotRequired;
}
